import React from 'react';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';

import ReactGA from 'react-ga';

import MainLayout from './layouts/MainLayout';
import DashboardPage from './pages/DashboardPage';
import WidgetPage from './pages/WidgetPage';
import EditorPage from './pages/EditorPage';
import UIGeneralPage from './pages/UIGeneralPage';
import UIPanelTabPage from './pages/UIPanelTabPage';
import UIIconsPage from './pages/UIIconsPage';
import UIButtonsPage from './pages/UIButtonsPage';

import TableSimplePage from './pages/TableSimplePage';
import CalendarPage from './pages/CalendarPage';
import MailboxPage from './pages/MailboxPage';
import MailReadPage from './pages/MailReadPage';
import MailWritePage from './pages/MailWritePage';

import ChartRechartsPage from './pages/ChartRechartsPage';

import FormGeneralPage from './pages/FormGeneralPage';

// config google analytics
const GA_ID = process.env && process.env.REACT_APP_GOOGLE_ANALYTICS;

if (GA_ID) {
  ReactGA.initialize(GA_ID);
}

const logPageView = () => {
  if (GA_ID) {
    ReactGA.set({ page: window.location.pathname + window.location.search });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
};

export default () => {
  return (
    <Router history={browserHistory} onUpdate={logPageView}>
      <Route path="/" component={MainLayout}>
        <IndexRoute component={DashboardPage} />
        <Route path="/dashboard" component={DashboardPage} />
        <Route path="/widgets" component={WidgetPage} />

        <Route path="/forms/general" component={FormGeneralPage} />
        <Route path="/forms/editor" component={EditorPage} />

        <Route path="/ui/general" component={UIGeneralPage} />
        <Route path="/ui/paneltab" component={UIPanelTabPage} />
        <Route path="/ui/icons" component={UIIconsPage} />
        <Route path="/ui/buttons" component={UIButtonsPage} />

        <Route path="/tables/simple" component={TableSimplePage} />

        <Route path="/calendar" component={CalendarPage} />
        <Route path="/mailbox" component={MailboxPage} />
        <Route path="/mailbox/read" component={MailReadPage} />
        <Route path="/mailbox/write" component={MailWritePage} />

        <Route path="/charts/recharts" component={ChartRechartsPage} />
      </Route>
    </Router>
  );
};



// WEBPACK FOOTER //
// ./src/routes.js